import React, {useState} from 'react';

import AnimatedCloseButtonComponent from '../animatedCloseButtonComponent/animatedCloseButtonComponent';
import OverlayComponent from '../overlayComponent/overlayComponent';
import Spinner from '../../spinner';

import './imagePreviewComponent.css';

const ImagePreviewComponent = ({
  isFullScreen = false,
  src = null,
  onClick = () => {},
  onClose = () => {}, //used if isFullScreen is true
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const onImageLoad = () => {
    setIsLoaded(true);
  };

  const onImageLoadError = () => {
    setIsLoaded(false);
  };

  return isFullScreen ? (
    <OverlayComponent>
      <div className="et-v2-image-preview-full-screen-container">
        <img className="et-v2-ipc-large-img" src={src} alt="img" />
        <AnimatedCloseButtonComponent onClick={onClose} />
      </div>
    </OverlayComponent>
  ) : (
    src && (
      <div className="et-v2-image-preview-small-container">
        <img
          src={src}
          className="et-v2-ipc-small-img"
          alt="img"
          onClick={onClick}
          onLoad={onImageLoad}
          onError={onImageLoadError}
        />
        {!isLoaded && (
          <div className="et-v2-image-preview-spinner-wrap">
            <Spinner />
          </div>
        )}
      </div>
    )
  );
};

export default ImagePreviewComponent;
